import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

import Calendar from "../../../assets/icons/Calendar.svg";

import * as S from "./styles";
import {
  Container,
  makeStyles,
  TextField,
  MenuItem,
} from "@material-ui/core";
import InputDateRange from "../../InputDateRange";
import { Autocomplete } from "@material-ui/lab";

import Grid from "@material-ui/core/Grid";

import ThemeButton from "../../ThemeButton";
import { useState } from "react";
import cleanStorageBeforeSearch from "../../../utils/cleanStorageBeforeSearch";
import CarRepository from "../../../repositories/carRepository";
import { useGlobal } from "../../../contexts/globalContext";
import IconedInput from "../../IconedInput";

import { getSessionStorage } from "../../../utils/getSessionStorage";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiFormHelperText-root.Mui-error": { color: "white" },
    opacity: 1,
    "& .MuiInputBase-input": { color: "#FFF" },
    "& label.Mui-focused": { color: "#FFF" },
    "& .MuiInput-underline:after": { borderBottomColor: "#FFF", color: "#FFF" },
    "& .MuiFormLabel-root": { color: "#FFF", opacity: 0.45 },
    "& .MuiSelect-icon": { color: "#FFF" },
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#FFF", color: "#FFF" },
      "&:hover fieldset": { borderColor: "#FFF", color: "#FFF", borderWidth: 2 },
      "&.Mui-focused fieldset": { borderColor: "#FFF", color: "#FFF" },
      "&.Mui-error fieldset": { borderColor: "#FFF" },
    },
  },
  fieldHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
  },
  fieldLabel: {
    fontSize: 11,
    fontWeight: 600,
    letterSpacing: "0.08em",
    color: "rgba(255,255,255,0.65)",
    textTransform: "uppercase",
  },
  typeToggle: {
    display: "flex",
    flexDirection: "row",
    gap: 4,
  },
  typeBtn: {
    background: "transparent",
    border: "1px solid rgba(255,255,255,0.35)",
    borderRadius: 20,
    color: "rgba(255,255,255,0.55)",
    fontSize: 11,
    fontWeight: 500,
    padding: "2px 10px",
    cursor: "pointer",
    outline: "none",
  },
  typeBtnActive: {
    background: "rgba(255,255,255,0.18)",
    borderColor: "#fff",
    color: "#fff",
    fontWeight: 700,
  },
  sameLocationCard: {
    border: "1px dashed rgba(255,255,255,0.3)",
    borderRadius: 4,
    minHeight: 56,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    color: "rgba(255,255,255,0.5)",
    fontSize: 13,
    letterSpacing: "0.02em",
    marginTop: 27, // aligns with the Autocomplete below the pickup fieldHeader
    "&:hover": {
      borderColor: "rgba(255,255,255,0.7)",
      color: "#fff",
    },
  },
  removeBtn: {
    background: "none",
    border: "none",
    color: "rgba(255,255,255,0.6)",
    cursor: "pointer",
    marginLeft: "auto",
    fontSize: 16,
    padding: 0,
  },
  optionRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "2px 0",
    width: "100%",
  },
  optionText: {
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    flex: 1,
  },
  optionName: {
    fontWeight: 500,
    fontSize: 14,
    color: "#222",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  optionDetail: {
    fontSize: 11,
    color: "#888",
    marginTop: 1,
  },
  iataBadge: {
    flexShrink: 0,
    background: "#1565c0",
    color: "#fff",
    borderRadius: 4,
    padding: "2px 7px",
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: "0.05em",
  },
}));

const CarSearchInputs = () => {
  let history = useHistory();
  const { showAlert, user } = useGlobal();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const carRepository = new CarRepository();

  const [options, setOptions] = useState([]);
  const [send, setSend] = useState(false);
  const [pickupTab, setPickupTab] = useState(0);
  const [dropoffTab, setDropoffTab] = useState(0);

  const classes = useStyles();

  const initialState = {
    cidadeRetirada: "",
    horaRetirada: "10:00",
    cidadeDevolucao: "",
    horaDevolucao: "10:00",
    datas: "",
    mesmoLocal: true,
  };

  const changeOptions = async (value) => {
    if (value.length >= 3) {
      try {
        const res = await carRepository.searchAutoComplete(value);
        setOptions(res.data || []);
      } catch (e) {
        setOptions([]);
      }
    }
  };

  const SelectHours = () => {
    return hoursArray.map((count, index) => (
      <MenuItem key={index} value={count}>
        {count}
      </MenuItem>
    ));
  };

  const [state, setState] = useState(initialState);

  const handleSubmit = () => {
    setSend(true);
    setSend(false);
    cleanStorageBeforeSearch();
    sessionStorage.setItem("carSearch", JSON.stringify(state));
    sessionStorage.setItem("buscaAtual", "Carro");
    if (
      state.cidadeRetirada === "" ||
      state.datas === "" ||
      state.horaDevolucao === "" ||
      state.horaRetirada === ""
    ) {
      showAlert("error", "Por favor, preencha todos os campos");
    } else if (!state.mesmoLocal) {
      if (state.cidadeDevolucao === "") {
        showAlert("error", "Por favor, preencha todos os campos");
      } else {
        history.push("/busca/resultado-pesquisa");
      }
    } else {
      history.push("/busca/resultado-pesquisa");
    }
  };

  useEffect(() => {
    const car = getSessionStorage("carSearch");
    if (car) setState(car);
  }, []);

  return (
    <S.Wrapper>
      <Container>
        <div className="origem-destino-control">
          <Grid container spacing={3}>
            {/* ROW 1 — LOCATIONS */}

            {/* PICKUP (always visible) */}
            <Grid item xs={12} md={6}>
              <div className={classes.fieldHeader}>
                <span className={classes.fieldLabel}>Retirada</span>
                <div className={classes.typeToggle}>
                  <button
                    className={`${classes.typeBtn} ${pickupTab === 0 ? classes.typeBtnActive : ""}`}
                    onClick={() => { setPickupTab(0); setState((s) => ({ ...s, cidadeRetirada: "" })); }}
                  >
                    Aeroportos
                  </button>
                  <button
                    className={`${classes.typeBtn} ${pickupTab === 1 ? classes.typeBtnActive : ""}`}
                    onClick={() => { setPickupTab(1); setState((s) => ({ ...s, cidadeRetirada: "" })); }}
                  >
                    Cidades
                  </button>
                </div>
              </div>
              <Autocomplete
                freeSolo
                disableClearable
                className={classes.root}
                noOptionsText="Nao encontrado"
                options={options}
                getOptionLabel={(option) =>
                  option
                    ? option.type === "A" && option.iata
                      ? `${option.name} (${option.iata})`
                      : `${option.name}`
                    : ""
                }
                filterOptions={(x) =>
                  pickupTab === 0
                    ? x.filter((o) => o.type === "A")
                    : x.filter((o) => o.type !== "A")
                }
                renderOption={(option) => (
                  <div className={classes.optionRow}>
                    <span className={classes.optionText}>
                      <span className={classes.optionName}>{option.name}</span>
                      {(option.state || option.country) && (
                        <span className={classes.optionDetail}>
                          {[option.state, option.country].filter(Boolean).join(", ")}
                        </span>
                      )}
                    </span>
                    {option.type === "A" && option.iata && (
                      <span className={classes.iataBadge}>{option.iata}</span>
                    )}
                  </div>
                )}
                onInputChange={(_, value, reason) => {
                  if (reason === "input") changeOptions(value);
                }}
                value={state.cidadeRetirada !== "" ? state.cidadeRetirada : ""}
                onChange={(_, newValue) => {
                  setState({ ...state, cidadeRetirada: newValue || "" });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={pickupTab === 0 ? "Aeroporto de Retirada" : "Cidade de Retirada"}
                    variant="outlined"
                    fullWidth
                    className={classes.root}
                    error={send && state.cidadeRetirada === ""}
                    helperText={send && state.cidadeRetirada === "" ? "Cidade de retirada nao pode ser vazio!" : " "}
                  />
                )}
              />
            </Grid>

            {/* DROPOFF — dashed card OR full dropoff field */}
            <Grid item xs={12} md={6}>
              {state.mesmoLocal ? (
                <div
                  className={classes.sameLocationCard}
                  onClick={() => setState({ ...state, mesmoLocal: false, cidadeDevolucao: "" })}
                >
                  + Devolver em outro local
                </div>
              ) : (
                <>
                  <div className={classes.fieldHeader}>
                    <span className={classes.fieldLabel}>Devolucao</span>
                    <div className={classes.typeToggle}>
                      <button
                        className={`${classes.typeBtn} ${dropoffTab === 0 ? classes.typeBtnActive : ""}`}
                        onClick={() => { setDropoffTab(0); setState((s) => ({ ...s, cidadeDevolucao: "" })); }}
                      >
                        Aeroportos
                      </button>
                      <button
                        className={`${classes.typeBtn} ${dropoffTab === 1 ? classes.typeBtnActive : ""}`}
                        onClick={() => { setDropoffTab(1); setState((s) => ({ ...s, cidadeDevolucao: "" })); }}
                      >
                        Cidades
                      </button>
                      <button
                        className={classes.removeBtn}
                        onClick={() => setState({ ...state, mesmoLocal: true, cidadeDevolucao: "" })}
                      >
                        &#10005;
                      </button>
                    </div>
                  </div>
                  <Autocomplete
                    freeSolo
                    disableClearable
                    className={classes.root}
                    noOptionsText="Nao encontrado"
                    options={options}
                    getOptionLabel={(option) =>
                      option
                        ? option.type === "A" && option.iata
                          ? `${option.name} (${option.iata})`
                          : `${option.name}`
                        : ""
                    }
                    filterOptions={(x) =>
                      dropoffTab === 0
                        ? x.filter((o) => o.type === "A")
                        : x.filter((o) => o.type !== "A")
                    }
                    renderOption={(option) => (
                      <div className={classes.optionRow}>
                        <span className={classes.optionText}>
                          <span className={classes.optionName}>{option.name}</span>
                          {(option.state || option.country) && (
                            <span className={classes.optionDetail}>
                              {[option.state, option.country].filter(Boolean).join(", ")}
                            </span>
                          )}
                        </span>
                        {option.type === "A" && option.iata && (
                          <span className={classes.iataBadge}>{option.iata}</span>
                        )}
                      </div>
                    )}
                    onInputChange={(_, value, reason) => {
                      if (reason === "input") changeOptions(value);
                    }}
                    onChange={(_, newValue) => {
                      setState({ ...state, cidadeDevolucao: newValue || "" });
                    }}
                    value={state.cidadeDevolucao !== "" ? state.cidadeDevolucao : ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder={dropoffTab === 0 ? "Aeroporto de Devolucao" : "Cidade de Devolucao"}
                        variant="outlined"
                        fullWidth
                        className={classes.root}
                        error={send && state.cidadeDevolucao === ""}
                        helperText={send && state.cidadeDevolucao === "" ? "Cidade devolucao nao pode ser vazio!" : ""}
                      />
                    )}
                  />
                </>
              )}
            </Grid>

            {/* ROW 2 — TIME, DATE, SUBMIT */}

            <Grid item xs={6} md={3}>
              <IconedInput
                value={state.horaRetirada}
                select
                label="Hora Retirada"
                width={150}
                onChange={(e) => setState({ ...state, horaRetirada: e.target.value })}
              >
                {SelectHours()}
              </IconedInput>
            </Grid>

            <Grid item xs={6} md={3}>
              <IconedInput
                value={state.horaDevolucao}
                select
                label="Hora Devolucao"
                width={150}
                onChange={(e) => setState({ ...state, horaDevolucao: e.target.value })}
              >
                {SelectHours()}
              </IconedInput>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <InputDateRange
                value={state.datas.abreviada && state.datas.abreviada}
                icon={Calendar}
                label="Data ida/volta"
                width={190}
                onChange={(e) => setState({ ...state, datas: e })}
                error={send && state.datas === initialState.datas}
                helperText={send && state.datas === initialState.datas ? "Data nao pode ser vazia" : ""}
                minStartDays={user.campaign.advanceDaysCar ? user.campaign.advanceDaysCar : 7}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <ThemeButton onClick={handleSubmit} className="submit1">
                Buscar
              </ThemeButton>
            </Grid>
          </Grid>
        </div>
      </Container>
    </S.Wrapper>
  );
};

export default CarSearchInputs;

const hoursArray = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
  "23:59",
];
